export const contractAddress="0x1F2970e41e99BBFAde14a8C1aEabe4Ddf67791C4";
export const tuesdayContractAddress="0x2e61145eEA854a8c6ED02F8ECF5f1c0AcECD8861";

export const abi = [
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundNumber",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "number1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number2",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number3",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number4",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number5",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomNumber",
            "name": "guessNumber",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "star1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "star2",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomStars",
            "name": "guessStars",
            "type": "tuple"
          },
          {
            "internalType": "bool",
            "name": "status",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "winningPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "wininnigCategory",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ticketNumber",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winningIndex",
            "type": "uint256"
          }
        ],
        "indexed": false,
        "internalType": "struct Lottery.roundInfo",
        "name": "abc",
        "type": "tuple"
      }
    ],
    "name": "Info",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "version",
        "type": "uint8"
      }
    ],
    "name": "Initialized",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w1",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w2",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w3",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w4",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w5",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w6",
        "type": "uint256"
      }
    ],
    "name": "Winners",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_number1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_star1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_star2",
        "type": "uint256"
      }
    ],
    "name": "addGuessNumber",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_number1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_star1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_star2",
        "type": "uint256"
      }
    ],
    "name": "addWinningNumber",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "annouceWinner",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "buyTicket",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "buyTickets",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_distributionFee1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee6",
        "type": "uint256"
      }
    ],
    "name": "changeDistributionFee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_maintenanceAndStakeHolderAddress",
        "type": "address"
      }
    ],
    "name": "changeMaintenaceAndStakeHoldersAddress",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_fee",
        "type": "uint256"
      }
    ],
    "name": "changeMaintenaceAndStakeHoldersFee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_price",
        "type": "uint256"
      }
    ],
    "name": "changeTicketPrice",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "cooldownTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "distributionFee",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "prize1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize6",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getBalance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getCurrentTotalPlayers",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalBuyTickets",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_roundNumber",
        "type": "uint256"
      }
    ],
    "name": "getYourHistory",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundNumber",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "number1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number2",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number3",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number4",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number5",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomNumber",
            "name": "guessNumber",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "star1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "star2",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomStars",
            "name": "guessStars",
            "type": "tuple"
          },
          {
            "internalType": "bool",
            "name": "status",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "winningPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "wininnigCategory",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ticketNumber",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winningIndex",
            "type": "uint256"
          }
        ],
        "internalType": "struct Lottery.roundInfo[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "round",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "_personAddress",
        "type": "address"
      }
    ],
    "name": "getYourHistoryPerRound",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundNumber",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "number1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number2",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number3",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number4",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number5",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomNumber",
            "name": "guessNumber",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "star1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "star2",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomStars",
            "name": "guessStars",
            "type": "tuple"
          },
          {
            "internalType": "bool",
            "name": "status",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "winningPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "wininnigCategory",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ticketNumber",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winningIndex",
            "type": "uint256"
          }
        ],
        "internalType": "struct Lottery.roundInfo[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "historyOfLotteryPrizeWinners",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "prize1Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize2Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize3Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize4Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize5Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize6Winners",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "historyOfPrizePerPersonAmounts",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "prize1PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize2PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize3PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize4PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize5PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize6PerPersonAmount",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "historyOfPrizeTotalAmounts",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "totalPoolPrize",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "drawnDate",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "totalPlayers",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize1TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize2TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize3TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize4TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize5TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize6TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "maintenaceAndStakeHoldersAmount",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "historyOfWinnigNumbers",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "number1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "number2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "number3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "number4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "number5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "star1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "star2",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_usdt",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_maintenaceAndStakeHolders",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "_maintenaceAndStakeHoldersFee",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_ticketPrice",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee6",
        "type": "uint256"
      }
    ],
    "name": "initialize",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isLotteryStarted",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isTicketCanBeSold",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "isTicketSold",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isTuesdayLotteryActive",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "lotteryEndTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "lotteryStartTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maintenaceAndStakeHolders",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maintenaceAndStakeHoldersFee",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "reset",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "roundNumber",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_cooldownTime",
        "type": "uint256"
      }
    ],
    "name": "setCooldownTime",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_isTicketCanBeSold",
        "type": "bool"
      }
    ],
    "name": "setIsTicketCanBeSold",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_lotteryEndTime",
        "type": "uint256"
      }
    ],
    "name": "setLotteryEndTime",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_lotteryStartTime",
        "type": "uint256"
      }
    ],
    "name": "setLotteryStartTime",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_isActive",
        "type": "bool"
      }
    ],
    "name": "setTuesdayLotteryActive",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_tuesdayLotteryAddress",
        "type": "address"
      }
    ],
    "name": "setTuesdayLotteryAddress",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_lotteryStartTime",
        "type": "uint256"
      }
    ],
    "name": "startLottery",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "stopLottery",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "ticketPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnerShip",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "tuesdayLotteryAddress",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "usdt",
    "outputs": [
      {
        "internalType": "contract IERC20",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "yourHistoryPerRound",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "roundNumber",
        "type": "uint256"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "number1",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "number2",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "number3",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "number4",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "number5",
            "type": "uint256"
          }
        ],
        "internalType": "struct Lottery.guessRandomNumber",
        "name": "guessNumber",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "star1",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "star2",
            "type": "uint256"
          }
        ],
        "internalType": "struct Lottery.guessRandomStars",
        "name": "guessStars",
        "type": "tuple"
      },
      {
        "internalType": "bool",
        "name": "status",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "winningPrice",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "wininnigCategory",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "ticketNumber",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "winningIndex",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
]

export const tuesdayAbi=[
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundNumber",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "number1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number2",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number3",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number4",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number5",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomNumber",
            "name": "guessNumber",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "star1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "star2",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomStars",
            "name": "guessStars",
            "type": "tuple"
          },
          {
            "internalType": "bool",
            "name": "status",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "winningPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "wininnigCategory",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ticketNumber",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winningIndex",
            "type": "uint256"
          }
        ],
        "indexed": false,
        "internalType": "struct Lottery.roundInfo",
        "name": "abc",
        "type": "tuple"
      }
    ],
    "name": "Info",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "version",
        "type": "uint8"
      }
    ],
    "name": "Initialized",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w1",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w2",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w3",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w4",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w5",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "w6",
        "type": "uint256"
      }
    ],
    "name": "Winners",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_number1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_star1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_star2",
        "type": "uint256"
      }
    ],
    "name": "addGuessNumber",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_number1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_number5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_star1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_star2",
        "type": "uint256"
      }
    ],
    "name": "addWinningNumber",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "annouceWinner",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "buyTicket",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "buyTickets",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_distributionFee1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee6",
        "type": "uint256"
      }
    ],
    "name": "changeDistributionFee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_maintenanceAndStakeHolderAddress",
        "type": "address"
      }
    ],
    "name": "changeMaintenaceAndStakeHoldersAddress",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_fee",
        "type": "uint256"
      }
    ],
    "name": "changeMaintenaceAndStakeHoldersFee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_price",
        "type": "uint256"
      }
    ],
    "name": "changeTicketPrice",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "cooldownTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "distributionFee",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "prize1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize6",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "fridayLotteryAddress",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getBalance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getCurrentTotalPlayers",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalBuyTickets",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_roundNumber",
        "type": "uint256"
      }
    ],
    "name": "getYourHistory",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundNumber",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "number1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number2",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number3",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number4",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number5",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomNumber",
            "name": "guessNumber",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "star1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "star2",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomStars",
            "name": "guessStars",
            "type": "tuple"
          },
          {
            "internalType": "bool",
            "name": "status",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "winningPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "wininnigCategory",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ticketNumber",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winningIndex",
            "type": "uint256"
          }
        ],
        "internalType": "struct Lottery.roundInfo[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "round",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "_personAddress",
        "type": "address"
      }
    ],
    "name": "getYourHistoryPerRound",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "roundNumber",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "number1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number2",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number3",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number4",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "number5",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomNumber",
            "name": "guessNumber",
            "type": "tuple"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "star1",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "star2",
                "type": "uint256"
              }
            ],
            "internalType": "struct Lottery.guessRandomStars",
            "name": "guessStars",
            "type": "tuple"
          },
          {
            "internalType": "bool",
            "name": "status",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "winningPrice",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "wininnigCategory",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "ticketNumber",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "winningIndex",
            "type": "uint256"
          }
        ],
        "internalType": "struct Lottery.roundInfo[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "historyOfLotteryPrizeWinners",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "prize1Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize2Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize3Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize4Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize5Winners",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize6Winners",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "historyOfPrizePerPersonAmounts",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "prize1PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize2PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize3PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize4PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize5PerPersonAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize6PerPersonAmount",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "historyOfPrizeTotalAmounts",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "totalPoolPrize",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "drawnDate",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "totalPlayers",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize1TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize2TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize3TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize4TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize5TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "prize6TotalAmount",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "maintenaceAndStakeHoldersAmount",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "historyOfWinnigNumbers",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "number1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "number2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "number3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "number4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "number5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "star1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "star2",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_usdt",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_maintenaceAndStakeHolders",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "_maintenaceAndStakeHoldersFee",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_ticketPrice",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee2",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee3",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee4",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee5",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_distributionFee6",
        "type": "uint256"
      }
    ],
    "name": "initialize",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isFridayLotteryActive",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isLotteryStarted",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isTicketCanBeSold",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "isTicketSold",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "lotteryEndTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "lotteryStartTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maintenaceAndStakeHolders",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maintenaceAndStakeHoldersFee",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "reset",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "roundNumber",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_cooldownTime",
        "type": "uint256"
      }
    ],
    "name": "setCooldownTime",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_isActive",
        "type": "bool"
      }
    ],
    "name": "setFridayLotteryActive",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_fridayLotteryAddress",
        "type": "address"
      }
    ],
    "name": "setFridayLotteryAddress",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_isTicketCanBeSold",
        "type": "bool"
      }
    ],
    "name": "setIsTicketCanBeSold",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_lotteryEndTime",
        "type": "uint256"
      }
    ],
    "name": "setLotteryEndTime",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_lotteryStartTime",
        "type": "uint256"
      }
    ],
    "name": "setLotteryStartTime",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_lotteryStartTime",
        "type": "uint256"
      }
    ],
    "name": "startLottery",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "stopLottery",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "ticketPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnerShip",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "usdt",
    "outputs": [
      {
        "internalType": "contract IERC20",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "yourHistoryPerRound",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "roundNumber",
        "type": "uint256"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "number1",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "number2",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "number3",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "number4",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "number5",
            "type": "uint256"
          }
        ],
        "internalType": "struct Lottery.guessRandomNumber",
        "name": "guessNumber",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "star1",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "star2",
            "type": "uint256"
          }
        ],
        "internalType": "struct Lottery.guessRandomStars",
        "name": "guessStars",
        "type": "tuple"
      },
      {
        "internalType": "bool",
        "name": "status",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "winningPrice",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "wininnigCategory",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "ticketNumber",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "winningIndex",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
]